// extracted by mini-css-extract-plugin
module.exports = {"header__search-bar-empty":"HeaderSearchBarNoResults_header__search-bar-empty__jWQDE","header__search-bar-mobile":"HeaderSearchBarNoResults_header__search-bar-mobile__ryWsM"};